import Navbar from "../../components/general/Navbar";
import BuyerProfile from "../../components/buyers/BuyerProfile";
import Footer from "../../components/general/Footer";

export default function BuyerProfilePage() {
  return (
    <>
      <Navbar />
      <BuyerProfile />
      <Footer />
    </>
  )
}

